<template>
	<div style="padding: 20px;display: flex;flex-direction: column;color:#fff;font-size: 14px;width: 50%;">
		<div style="flex:1;background-color: rgb(75, 83, 87);display: flex;flex-direction: column;">
			<div style="padding: 15px;border-bottom: 1px solid #3f4649;display: flex;align-items: center;justify-content: space-between;">
				销售统计
				<div style="display: flex;align-items: center;">
					<span style="margin-right: 10px;">共{{total}}条数据</span>
					<el-button icon="el-icon-refresh" type="primary" size="small" style="border-radius: 0;" @click="getData">刷新数据</el-button>
				</div>
			</div>
			<div style="padding: 15px 25px;display: flex;align-items: center;" class="search">
				<el-select v-model="form.software_id" clearable placeholder="请所属软件"
					style="width: 150px;margin-right: 10px;" @change="search" size="small">
					<el-option v-for="(item,index) in software_list" :key="index" :label="item.name"
						:value="item.id">
					</el-option>
				</el-select>
			</div>
			<div style="padding: 0px 20px 0px 20px;">
				<el-table :data="list" stripe
					style="width: 100%;flex: 1;padding:0px 0px;background-color: rgb(75, 83, 87);color: #fff;"
					size="small"
					:header-cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}"
					:cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}"
					:row-style="{border_color:'rgb(75, 83, 87)'}" height="300" v-loading="loading">
					<el-table-column label="日期" align="left" >
						<template slot-scope="scope">
							{{scope.row.date}}
						</template>
					</el-table-column>
					<el-table-column label="金额" align="center">
						<template slot-scope="scope">
							{{scope.row.total_fee/100}}
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="footer">
				<el-pagination layout="total, prev, pager, next" @current-change="toPage" :total="total"
					:page-sizes="[10,50,100,500,1000]" :current-page="form.page" :page-size="limit">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		data() {
			return {
				loading: false,
				form: {
					page:1,
					software_id:''
				},
				total:0,
				limit:15,
				list: [],
				software_list:[]
			}
		},
		computed: {
			...mapState({
				user: state => state.user,
				reload:state=>state.reload
			})
		},
		watch:{
			reload(n,v){
				this.getData()
			}
		},
		filters:{
			time_split(time_str,index){
				return time_str.split(' ')[index];
			}
		},
		created() {
			this.getSoftwareList()
			this.getData()
		},
		methods: {
			getSoftwareList(){
				this.$H.post('verify_center/v1_0_1.Software/list').then(res => {
					if(res.data){
						this.software_list = res.data.list;
					}
					
				});
			},
			search() {
				this.form.page = 1
				this.getData()
			},
			getData() {
				this.loading = true
				this.$H.post('/verify_center/v1_0_2.Amount/HistoryCount', this.form).then(res => {
					this.loading = false
					if (res.data) {
						if (this.form.page === 1) {
							this.total = res.data.list.total
						}
						this.list = res.data.list.data

					}
				}).catch(err => {
					this.loading = false
				})
			},
			toPage(val) {
				this.form.page = val
				this.getData()
			}
		}
	}
</script>

<style>
	.search input {
		background-color: rgb(75, 83, 87);
		color: #fff;
		border-radius: 0px;

	}

	.el-dialog__header {
		background-color: #409EFF;
		color: #fff;
	}

	.el-dialog__header .el-dialog__title {
		color: #fff;
	}

	.el-dialog__close el-icon el-icon-close {
		color: #fff;
	}

	.footer {
		margin-top: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px 0;
	}

	.footer .el-pagination__total {
		color: #fff !important;
	}

	.footer input {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
		border-radius: 0;
	}

	.footer>>>.btn-prev {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
	}

	.el-table td.el-table__cell,
	.el-table th.el-table__cell.is-leaf {
		border-bottom: 1px solid #909399 !important;
	}
</style>